<script>
  /**
   * One message box of the password-recovery pages.
   * `tone`: `error` (red), `success` (green) or `info` (cyan).
   */
  export let tone = 'info';
  /** Test hook. */
  export let testid = undefined;

  const TONES = {
    error: { border: 'border-red-500', color: 'text-red-400', background: 'rgba(239, 68, 68, 0.1)' },
    success: { border: 'border-green-500', color: 'text-green-500', background: 'rgba(34, 197, 94, 0.1)' },
    info: { border: 'border-primary-500', color: 'text-primary-500', background: 'rgba(0, 191, 255, 0.08)' },
  };
  $: style = TONES[tone] ?? TONES.info;
</script>

<div
  class="border-2 p-4 scale-in {style.border}"
  style="background-color: {style.background};"
  role={tone === 'error' ? 'alert' : 'status'}
  data-testid={testid}
>
  <p class="text-sm font-bold {style.color}"><slot /></p>
</div>
